<template>
  <div>
    <basic-container>
      <avue-crud
        :option="tableOption"
        :data="tableData"
        :table-loading="tableLoading"
        :page="page"
        ref="crud"
        @search-change="searchChange"
        @refresh-change="refreshChange"
        @row-save="handleSave"
        @row-update="handleUpdate"
        :before-close="closeDialogBefore"
        @selection-change="handleSelectionChange"
        @size-change="pageSizeChange"
        @current-change="pageChange"
      >
        <template
          slot-scope="scope"
          slot="menuLeft"
        >
          <el-button
            type="primary"
            icon="el-icon-plus"
            size="small"
            plain
            @click.stop="handleAdd()"
          >新增</el-button>
        </template>
        <template
          slot-scope="scope"
          slot="menu"
        >
          <el-button
            type="success"
            icon="el-icon-view"
            size="small"
            plain
            @click.stop="handleDetail(scope.row,scope.index)"
          >查看</el-button>

        </template>

        <template
          slot-scope="scope"
          slot="serviceCategory"
        >
          <el-tag v-if="scope.row.serviceCategoryName != null">{{scope.row.serviceCategoryName}}</el-tag>
        </template>
        <template
          slot-scope="scope"
          slot="provinceForm"
        >
          <el-input
            type="input"
            name="title"
            :value="point.pname"
            disabled
          ></el-input>
        </template>
        <template
          slot-scope="scope"
          slot="cityForm"
        >
          <el-input
            type="input"
            name="title"
            :value="point.cityname"
            disabled
          ></el-input>
        </template>
        <template
          slot-scope="scope"
          slot="areaForm"
        >
          <el-input
            type="input"
            name="title"
            :value="point.adname"
            disabled
          ></el-input>
        </template>
        <template
          slot-scope="scope"
          slot="provincesForm"
        >
          <avue-map v-model="point"></avue-map>
        </template>
        <template
          slot-scope="scope"
          slot="serviceCategoryForm"
        >
          <el-select
            v-model="serviceCategory"
            placeholder="请选择服务类目"
            required
            @change="choseWorkServiceItem"
            value-key="id"
          >
            <el-option
              v-for="serviceCategory in serviceCategorys"
              :key="serviceCategory.id"
              :label="serviceCategory.name"
              :value="serviceCategory"
            ></el-option>
          </el-select>
        </template>
        <template
          slot-scope="props"
          slot="expand"
        >
          <el-table
            :data="props.row.childList"
            border
            style="width: 100%"
            size="mini"
          >
            <el-table-column
              property="serviceItemName"
              label="工单类型"
              align="center"
            ></el-table-column>
            <el-table-column
              property="realName"
              label="工程师"
              align="center"
            ></el-table-column>
            <el-table-column
              property="serviceTime"
              label="工期开始时间"
              :formatter="formatterServiceTime"
              align="center"
            >
            </el-table-column>
            <el-table-column
              property="endTime"
              label="工期结束时间"
              :formatter="formatterEndTime"
              align="center"
            >
            </el-table-column>
            <el-table-column
              property="totalMoney"
              label="服务费用"
              align="center"
            ></el-table-column>
            <el-table-column
              property="mobile"
              label="联系电话"
              align="center"
            ></el-table-column>
            <el-table-column
              property="status"
              label="状态"
              :formatter="transStatusName"
              align="center"
            >
            </el-table-column>
            <el-table-column
              property="option"
              label="操作"
              align="center"
            >
              <template slot-scope="scope">
                <template v-for="dsrmsButton in dsrmsButtons">
                  <div :key="dsrmsButton.id">
                    <el-button
                      type="default"
                      icon="el-icon-check"
                      size="small"
                      plain
                      v-if="handleDsrms(scope.row, dsrmsButton)"
                      @click.stop="statusOption(dsrmsButton.step, scope.row)"
                    >{{ dsrmsButton.name }}</el-button>
                  </div>
                </template>
                <el-button
                  type="success"
                  icon="el-icon-view"
                  size="small"
                  plain
                  @click.stop="openOptionHistory(scope.row)"
                >操作历史</el-button>
              </template>
            </el-table-column>
          </el-table>
        </template>
        <template
          slot-scope="scope"
          slot="childListForm"
        >
          <div>
            <el-table
              :data="childList"
              border
            >
              <el-table-column
                prop="serviceItemId"
                align="center"
                label="服务项目"
              >
                <template slot-scope="scope">
                  <el-select
                    v-model="scope.row.serviceItemId"
                    placeholder="请选择服务项目"
                    required
                    @change="choseServiceItem"
                    value-key="id"
                  >
                    <el-option
                      v-for="joinsWorkServiceItem in joinsWorkServiceItems"
                      :key="joinsWorkServiceItem.id"
                      :label="joinsWorkServiceItem.name"
                      :value="joinsWorkServiceItem.id"
                    ></el-option>
                  </el-select>
                </template>

              </el-table-column>
              <el-table-column
                prop="serviceTime"
                align="center"
                label="服务时间"
              >
                <template slot-scope="scope">
                  <el-date-picker
                    v-model="scope.row.serviceTime"
                    type="datetime"
                    placeholder="选择服务时间"
                    value-format="timestamp"
                    default-time="12:00:00"
                  >
                  </el-date-picker>
                </template>
              </el-table-column>
              <el-table-column
                prop="endTime"
                align="center"
                label="工程结束时间"
              >
                <template slot-scope="scope">
                  <el-date-picker
                    v-model="scope.row.endTime"
                    type="datetime"
                    placeholder="选择工程结束时间"
                    value-format="timestamp"
                    default-time="12:00:00"
                  >
                  </el-date-picker>
                </template>
              </el-table-column>
              <el-table-column
                prop="workerUserId"
                align="center"
                label="工程师"
              >
                <template slot-scope="scope">
                  <el-select
                    name="propertiesType"
                    v-model="scope.row.workerUserId"
                    placeholder="请选择工程师"
                    :value="scope.row.workerUserId"
                  >
                    <el-option
                      v-for="user in users"
                      :key="user.id"
                      :label="user.realName"
                      :value="user.id"
                    >
                    </el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column
                align="center"
                label="操作"
              >
                <template slot-scope="scope">
                  <el-button
                    type="warning"
                    icon="el-icon-check"
                    size="small"
                    @click="handleSteppingDelete(scope.$index, scope.row)"
                  >删除</el-button>
                </template>
              </el-table-column>
            </el-table>
            <div style="margin-top: 20px">
              <el-button @click="handleAddRows()">增加一行</el-button>
            </div>
          </div>
        </template>
      </avue-crud>
      <template>
        <el-dialog
          title="操作历史"
          :visible.sync="resourceHistoryDialog"
          align="center"
        >
          <el-table
            :data="resourceHistoryData"
            border
            max-height="400"
          >
            <el-table-column
              property="step"
              label="当前步进"
              width="80"
            ></el-table-column>
            <el-table-column
              property="lastStep"
              label="上一步"
              width="70"
            ></el-table-column>
            <el-table-column
              property="code"
              label="状态值"
            ></el-table-column>
            <el-table-column
              property="name"
              label="状态名称"
              width="80"
            ></el-table-column>
            <el-table-column
              property="lastCode"
              label="上一步状态值"
            ></el-table-column>
            <el-table-column
              property="lastName"
              label="上一步状态名称"
              width="120"
            ></el-table-column>
            <el-table-column
              property="resourceType"
              label="资源类型"
            ></el-table-column>
            <el-table-column
              property="optionBy"
              label="操作人"
              width="100"
            ></el-table-column>
            <el-table-column
              property="time"
              label="操作时间"
            >
              <template slot-scope="scope">
                <span style="margin-left: 10px">{{ formatterHistoryTime(scope.row.time) }}</span>
              </template>
            </el-table-column>
            <el-table-column
              property="remarks"
              label="备注"
            >
            </el-table-column>
          </el-table>
        </el-dialog>
      </template>
      <template>
        <el-dialog
          title="二维码支付"
          :visible.sync="QRCodeDialog"
          align="center"
        >
          <vue-qr
            :text="config.value"
            :size="200"
          ></vue-qr>
          <el-button @click="QRCodeDialog = false">关闭</el-button>
        </el-dialog>
      </template>
    </basic-container>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { engineeringOrderTableOption } from "@/const/salesCloud/engineeringOrderOption";
import {
  findWorkOrderListManage,
  addWorkOrder,
  findCategoryAll,
  findItemsByCategory,
  dsrmsUpdate,
  findResrouceHistory,
  findUsersByUserType
} from "@/api/salesCloud/engineeringOrder";
import {
  findByLabel,
  getStatusName,
  getStepObj,
  getMenuSteps,
  formatterTime
} from "@/util/util";

import VueQr from "vue-qr";

export default {
  name: "engineeringOrder",
  components: {
    VueQr
  },
  data() {
    return {
      tableOption: engineeringOrderTableOption, //表格设置属性
      tableData: [], //表格的数据
      tablePage: 1,
      tableLoading: false,
      QRCodeDialog: false,
      resourceHistoryDialog: false,
      resourceHistoryData: [],
      tabelObj: {},
      resourceType: "JOINS_WORK_ORDER", // 动态状态管理的关键属性
      clientType: "JOINS_SYSTEM_MANAGE",
      steppings: [],
      page: {
        total: 0, //总页数
        currentPage: 1, //当前页数
        pageSize: 10 //每页显示多少条
      },
      grade: {
        box: false,
        check: []
      },
      dsrmsButtons: [],
      serviceCategorys: [],
      serviceCategory: {},
      childList: [],
      joinsWorkServiceItems: [],
      userType: "JOINS_ENGINEER",
      users: [],
      gaodeMap: {},
      point: {},
      config: {
        value: "www.baidu.com" //显示的值、跳转的地址
      }
    };
  },
  created() {
    let _clientType = this.clientType;
    this.$store.dispatch("getSteppings", this.resourceType).then(data => {
      this.steppings = data;
      this.dsrmsButtons = new Array();
      for (let stepping of this.steppings) {
        if (
          stepping.stepType == "OPTION" &&
          stepping.clientButtonType.indexOf(_clientType) != -1
        ) {
          this.dsrmsButtons.push(stepping);
        }
      }
    });
    findCategoryAll().then(res => {
      let data = JSON.parse(res.data);
      this.serviceCategorys = data.rows;
    });
    let params = new Object();
    params.userType = this.userType;
    findUsersByUserType(params).then(res => {
      let data = JSON.parse(res.data);
      this.users = data.rows;
    });
    this.handleList();
  },
  watch: {},
  mounted() {},
  computed: {
    ...mapGetters(["permission"])
  },
  props: [],
  methods: {
    formatterHistoryTime(time) {
      return formatterTime(time);
    },
    handleAddRows() {
      var list = {
        projectName: "",
        serviceTime: "",
        endTime: ""
      };
      this.childList.unshift(list);
    },
    handleSteppingDelete(index, row) {
      this.childList.splice(index, 1);
    },
    choseServiceItem(data) {
      console.log(data);
    },
    choseWorkServiceItem() {
      findItemsByCategory(this.serviceCategory.id).then(res => {
        let data = JSON.parse(res.data);
        this.joinsWorkServiceItems = data;
      });
    },
    formatterServiceTime(row) {
      if (null != row.serviceTime) {
        return formatterTime(row.serviceTime);
      }
    },
    formatterEndTime(row) {
      if (null != row.endTime) {
        return formatterTime(row.endTime);
      }
    },
    closeDialogBefore(done) {
      this.cleanForm();
      done();
    },
    openOptionHistory(row) {
      findResrouceHistory(row.id).then(response => {
        let data = JSON.parse(response.data);
        if (response.code == "200") {
          this.resourceHistoryData = data;
        }
      });
      this.resourceHistoryDialog = true;
    },
    handleDsrms(row, handleDsrms) {
      let menusSteps = getMenuSteps(this.steppings, row.status);
      for (let menu of menusSteps) {
        if (menu.step == handleDsrms.step) return true;
      }
      return false;
    },
    transStatusName(row) {
      return getStatusName(this.steppings, row.status);
    },
    statusOption(step, row) {
      let stepObj = getStepObj(this.steppings, step);
      this.$prompt("请输入信息备注", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputPattern: /^.{1,255}$/,
        inputErrorMessage: "请输入正确长度的备注信息1-255"
      }).then(({ value }) => {
        stepObj.remarks = value;
        stepObj.sourceId = row.id;
        stepObj.resourceType = this.resourceType;
        console.log(stepObj.code == "USER_PAY");
        if (stepObj.code == "USER_PAY") {
          let obj = new Object();
          obj.payType = "NATIVE";
          obj.channelId = 4;
          stepObj.paramMap = obj;
          dsrmsUpdate(stepObj).then(response => {
            let data = JSON.parse(response.data);
            if ((data.code = "200")) {
              this.config.value = data.codeUrl;
              this.QRCodeDialog = true;
            } else {
              this.$message({
                showClose: true,
                message: response.message,
                type: "error"
              });
            }
          });
        } else {
          dsrmsUpdate(stepObj).then(response => {
            if (response.code == "200") {
              this.$message({
                showClose: true,
                message: "操作成功",
                type: "success"
              });
              this.handleList();
            } else {
              this.$message({
                showClose: true,
                message: response.message,
                type: "error"
              });
            }
          });
        }
      });
    },
    pageSizeChange(pageSize) {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm;
      (params.page = this.page.currentPage), (params.size = pageSize);
      findWorkOrderListManage(params).then(res => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: this.page.currentPage,
          pageSize: pageSize
        };
        this.tableLoading = false;
      });
    },
    pageChange(page) {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm;
      params.page = page;
      params.size = this.page.pageSize;
      findWorkOrderListManage(params).then(res => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: page,
          pageSize: this.page.pageSize
        };
        this.tableLoading = false;
      });
    },
    searchChange(params) {
      this.tableLoading = true;
      // let params = this.$refs.crud.searchForm
      params.page = this.page.currentPage;
      params.size = this.page.pageSize;
      findWorkOrderListManage(params).then(res => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: params.page,
          pageSize: params.size
        };
        this.tableLoading = false;
      });
    },
    refreshChange(page) {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm;
      params.page = page.currentPage;
      params.size = page.pageSize;
      findWorkOrderListManage(params).then(res => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: page.currentPage,
          pageSize: page.pageSize
        };
        this.tableLoading = false;
      });
    },
    /**
     * @title 打开新增窗口
     * @detail 调用crud的handleadd方法即可
     *
     **/
    handleAdd() {
      this.$refs.crud.rowAdd();
    },
    handleDetail(row, index) {
      let location = new Object();
      location.lng = row.longitude;
      location.lat = row.latitude;
      this.point.location = location;
      this.point.pname = row.province;
      this.point.cityname = row.city;
      this.point.adname = row.area;
      this.childList = row.childList;
      this.serviceCategory = {
        id: row.serviceCategoryId
      };
      this.choseWorkServiceItem();
      this.$refs.crud.rowView(row, index);
    },
    handleEdit(row, index) {
      this.$refs.crud.rowEdit(row, index);
    },
    /**
     * @title 获取数据
     * @detail 赋值为tableData表格即可
     *
     **/
    handleList() {
      this.tableLoading = true;
      let parmas = {
        page: this.page.currentPage,
        size: this.page.pageSize
      };
      findWorkOrderListManage(parmas).then(res => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: this.page.currentPage,
          pageSize: this.page.pageSize
        };
        this.tableLoading = false;
      });
    },
    /**
     * @title 数据添加
     * @param row 为当前的数据
     * @param done 为表单关闭函数
     *
     **/
    handleSave(row, done) {
      row.serviceCategoryId = this.serviceCategory.id;
      row.childList = this.childList;
      row.longitude = this.point.location.lng;
      row.latitude = this.point.location.lat;
      row.provicne = this.point.pname;
      row.city = this.point.cityname;
      row.area = this.point.adname;
      addWorkOrder(row)
        .then(response => {
          if (response.code == "200") {
            this.$message({
              showClose: true,
              message: "添加成功",
              type: "success"
            });
            this.handleList();
          } else {
            this.$message({
              showClose: true,
              message: response.message,
              type: "error"
            });
          }
        })
        .catch(error => {
          this.loading = false;
          this.$message({
            showClose: true,
            message: error,
            type: "error"
          });
        });
      done();
    },
    /**
     * @title 当前选中的数据
     * @param val 选中的值
     *
     **/
    handleSelectionChange() {},
    /**
     * @title 数据删除
     * @param row 为当前的数据
     * @param index 为当前更新数据的行数
     *
     **/
    handleDel(dicName, label) {},
    /**
     * @title 数据更新
     * @param row 为当前的数据
     * @param index 为当前更新数据的行数
     * @param done 为表单关闭函数
     *
     **/
    handleUpdate(row, index, done) {
      done();
    }
  }
};
</script>

<style lang="scss">
.el-upload--text {
  text-align: left;
}
.el-upload--car-two {
  background-color: #fbfdff;
  border: 1px dashed #c0ccda;
  border-radius: 6px;
  box-sizing: border-box;
  width: 178px;
  height: 178px;
  line-height: 176px;
  vertical-align: top;
}
.el-upload--car-two image {
  width: 178px;
  height: 178px;
}
/*.el-upload .el-icon-plus{*/
/*text-align: center;*/
/*}*/
.table-container {
  padding: 8px 10px;
}
.demo-table-expand {
  font-size: 0;
}
.demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}
.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 50%;
}
</style>
